import { SkeletonElement, styled, breakpoints } from '@notino/react-styleguide';

type PDSkeletonProps = {
  marginTop?: number;
  marginBottom?: number;
  marginLeft?: number;
  marginRight?: number;
  display?: string;
};
export const PDSkeletonElement = styled(SkeletonElement)`
  margin-top: ${(props: PDSkeletonProps) =>
    props.marginTop ? `${props.marginTop}rem` : 0};
  margin-right: ${(props: PDSkeletonProps) =>
    props.marginRight ? `${props.marginRight}rem` : 0};
  margin-bottom: ${(props: PDSkeletonProps) =>
    props.marginBottom ? `${props.marginBottom}rem` : 0};
  margin-left: ${(props: PDSkeletonProps) =>
    props.marginLeft ? `${props.marginLeft}rem` : 0};

  display: ${(props: PDSkeletonProps) => props.display || 'block'};
`;

export const EmptySpace = styled.div`
  @media (min-width: ${breakpoints.md}) {
    height: 40vh;
  }
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
`;
